<template>
  <div class="container">
    <div class="name">
      <img src="../images/icon_yutang.png"/>
      <span>{{data.pondName}}</span>
      <span>（{{data.pondArea}}亩）</span>
    </div>
    <div class="info">
      <img src="../images/tempImage.png"/>
      <div class="info-inner">
        <div class="info-inner-row">
          <div class="info-inner-row-item">
            <span>鱼种：</span><span>{{data.farmFish}}</span>
          </div>
          <div class="info-inner-row-item" v-if="data.fishWeight && data.fishWeight > 0">
            <span>重量：</span><span>{{data.fishWeight}}斤</span>
          </div>
          <div class="info-inner-row-item" v-else>
            <span>数量：</span><span>{{data.fishQuantity}}尾</span>
          </div>
        </div>
        <div class="info-inner-row">
          <div class="info-inner-row-item">
            <span>密度：</span><span>{{data.fishDensity}}尾/亩</span>
          </div>
          <div class="info-inner-row-item">
            <span>用料：</span><span>{{data.fishFeed}}kg</span>
          </div>
        </div>
      </div>
    </div>
    <div class="border-radio top-left"></div>
    <div class="border-radio top-right"></div>
    <div class="border-radio bottom-left"></div>
    <div class="border-radio bottom-right"></div>
  </div>
</template>

<script>
export default {
  name: 'EquipmentInfo',
  data () {
    return {
    }
  },
  props: ['data'],
  methods: {
    
  },
  mounted () {
  },
  deleted () {
  }
}
</script>
<style scoped lang="stylus">
.container{
  width: 100%;
  height: 100%;
  background: #FFF;
  border: 2px solid #B2E7FF;
  box-shadow: 1px 1px 20px 0px rgba(0,0,0,0.12);
  border-radius: 10px;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  .name{
    display: flex;
    align-items: center;
    img{
      width: 40px;
      height: 41px;
    }
    span:nth-child(2){
      flex: 1;
      font-size: 22px;
      font-weight: 500;
      color: #333;
      margin: 0 19px 0 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:nth-child(3){
      font-size: 22px;
      color: #666;
    }
  }
  .info{
    width: 100%;
    height: 80%;
    position: relative;
    img{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .info-inner{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #08233950;
      padding: 10px;
      box-sizing: border-box;
      .info-inner-row{
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:&:nth-child(1){
          margin-bottom: 13px;
        }
        .info-inner-row-item{
          flex: 1;
          span:nth-child(1){
            font-size: 14px;
            color: #BBD4E9;
          }
          span:nth-child(2){
            font-size: 18px;
            color: #FFF;
          }
        }
      }
    }
  }
  .border-radio{
    width: 20px;
    height: 20px;
    border: 3px solid #1170B9;
    position: absolute;
    &.top-left{
      border-right: none;
      border-bottom: none;
      border-top-left-radius: 8px;
      top: -2px;
      left: -2px;
    }
    &.top-right{
      border-left: none;
      border-bottom: none;
      border-top-right-radius: 8px;
      top: -2px;
      right: -2px;
    }
    &.bottom-left{
      border-top: none;
      border-right: none;
      border-bottom-left-radius: 8px;
      left: -2px;
      bottom: -2px;
    }
    &.bottom-right{
      border-top: none;
      border-left: none;
      border-bottom-right-radius: 8px;
      right: -2px;
      bottom: -2px;
    }
  }
}
</style>
